import React from 'react';

const AvatarImg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="icon_avatar">
      <g
        id="icon_avatar_Components-/-Avatar-/-fallback-/-44"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="icon_avatar_Group">
          <use id="icon_avatar_Oval" fill="#F2F2F5" fillRule="nonzero" />
          <g id="icon_avatar_Fill-91" mask="url(#icon_avatar_mask-2)" fill="#C0C0C9">
            <path
              d="M.473 29.808a1.02 1.02 0 01-.346-.42c-.123-.246-.082-.479.102-.696.156-.24.45-.51.956-.805 2.063-1.204 5.136-2.309 8.124-3.375.73-.26 1.459-.521 2.168-.781v-3.357c-.923-.563-2.551-2.013-2.745-5.333-.713-.41-1.161-1.32-1.161-2.489 0-1.062.372-1.912.977-2.365-.435-1.53-1.207-4.308-.037-5.832.36-.467 1.08-1.027 2.378-.965C11.971 1.456 14.995.745 17.47.745c2.778 0 6.246.896 6.886 3.414.545 2.148-.262 4.67-.71 6.043.595.456.958 1.3.958 2.35 0 1.168-.45 2.078-1.161 2.489-.195 3.32-1.821 4.77-2.747 5.333v3.355c.791.289 1.58.57 2.352.847 3.08 1.096 5.988 2.138 7.933 3.268.426.19.72.398.854.626.156.265.313.893 0 1.206-4.192 4.185-9.786 6.49-15.748 6.49-5.897 0-11.434-2.255-15.613-6.358z"
              transform="translate(6 8)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default AvatarImg;
